<template>
  <div class="container">
    <ToolbarComp v-if="showTopBar"></ToolbarComp>

    <result-message></result-message>

    <div class="login-container">
      <img src="@/assets/logo.svg" alt="icono corporativo" class="logo-image" />

      <button class="google-button" @click="handleGoogleLogin">
        Iniciar sesión con Google
      </button>

      <!--button class="visitor-button" @click="goToVisitorMode">Entrar como visitante</button-->
    </div>

    <LoaderComp v-if="isLoading"></LoaderComp>
    <BottomBar v-if="showBottomBar"></BottomBar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ToolbarComp from '@/components/ToolbarComp';
import LoaderComp from '@/components/LoaderComp';
import ResultMessage from '@/components/ResultMessage';
import BottomBar from '@/components/BottomBar';

export default {
  name: 'app',
  components: {
    ToolbarComp, LoaderComp, ResultMessage, BottomBar
  },
  computed: {
    showBottomBar() {
      const dontShowIn = ['login', 'intro', 'select-turno', 'select-vehicle'];
      return dontShowIn.indexOf(this.$route.name) === -1;
    },
    showTopBar() {
      const dontShowIn = ['login', 'intro'];
      return dontShowIn.indexOf(this.$route.name) === -1;
    },
    ...mapGetters({
      isLoading: 'form/is-submiting'
    })
  },
  methods: {
    handleGoogleLogin() {
      if (window.gapi) {
        this.loadGoogleSdk();
      } else {
        console.error('gapi no está disponible. Asegúrate de que el script se carga correctamente.');
      }
    },
    loadGoogleSdk() {
      window.gapi.load('client:auth2', () => {
        window.gapi.client.init({
          clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
          scope: 'openid email profile'
        }).then(() => {
          this.signInWithGoogle();
        }).catch((error) => {
          console.error('Error al inicializar gapi:', error);
        });
      });
    },
    signInWithGoogle() {
      const auth2 = window.gapi.auth2.getAuthInstance();
      auth2.signIn().then((googleUser) => {
        const idToken = googleUser.getAuthResponse().id_token; // Obtén el ID token
        this.$store.dispatch('auth/loginWithGoogle', idToken); // Envía el ID token a tu backend
        this.$router.push({ name: 'home' });
      }).catch((error) => {
        console.error('Error en la autenticación:', error);
      });
    },
    goToVisitorMode() {
      this.$router.push({ name: 'home' });
    }
  }
}
</script>



<style scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-height: 100vh;
  background-color: #f6f6fa;
}

.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  text-align: center;
}

.logo-image {
  width: 150px;
  margin-bottom: 20px;
}

.google-button {
  background-color: #4285F4;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 100%;
}

.google-button:hover {
  background-color: #357AE8;
}

.visitor-button {
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 100%;
  margin-top: 20px;
}

.visitor-button:hover {
  background-color: #3e8e41;
}
</style>

